/**
 *
 * @module entry
 * @desc {SDK.Commerce} entry point.
 *
 */

import CommerceApi from './commerceApi';
import CommerceManager from './commerceManager';
import CreditCardType from './creditCardType';
import LineItem from './lineItem';
import PaymentInformation from './paymentInformation';
import PaymentMethodInformation from './paymentMethodInformation';
import PaymentMethodResponse from './paymentMethodResponse';
import CardPaymentMethodResponse from './cardPaymentMethodResponse';
import PaymentMethodType from './paymentMethodType';
import SubmitOrderRequest from './submitOrderRequest';
import SubmitOrderWithPaymentMethodRequest from './submitOrderWithPaymentMethodRequest';
import SubmitOrderWithCardPaymentMethodRequest from './submitOrderWithCardPaymentMethodRequest';

/**
 *
 * @typedef SDK.Commerce
 * @type {Object}
 *
 * @property {CommerceApi} CommerceApi
 * @property {CommerceManager} CommerceManager
 * @property {CardPaymentMethodResponse} CardPaymentMethodResponse
 * @property {CreditCardType} CreditCardType
 * @property {LineItem} LineItem
 * @property {PaymentInformation} PaymentInformation
 * @property {PaymentMethodInformation} PaymentMethodInformation
 * @property {PaymentMethodResponse} PaymentMethodResponse
 * @property {PaymentMethodType} PaymentMethodType
 * @property {SubmitOrderRequest} SubmitOrderRequest
 * @property {SubmitOrderWithPaymentMethodRequest} SubmitOrderWithPaymentMethodRequest
 * @property {SubmitOrderWithCardPaymentMethodRequest} SubmitOrderWithCardPaymentMethodRequest
 *
 */

/**
 *
 * @type {SDK.Commerce}
 *
 */
export default {

    CommerceApi,
    CommerceManager,
    CardPaymentMethodResponse,
    CreditCardType,
    LineItem,
    PaymentInformation,
    PaymentMethodInformation,
    PaymentMethodResponse,
    PaymentMethodType,
    SubmitOrderRequest,
    SubmitOrderWithPaymentMethodRequest,
    SubmitOrderWithCardPaymentMethodRequest

};



// WEBPACK FOOTER //
// ./src/commerce/entry.js